// src/components/Privacy.js
// Politique de confidentialité (données personnelles). Distincte des CGU (Terms.js).
// Page publique (accessible sans connexion) — URL exigée par les stores.
import React from "react";
import { useTranslation } from "react-i18next";

const PRIVACY_VERSION = "2026-09-13";

export default function Privacy() {
    const { t } = useTranslation();

    const S = (key) => t(`privacy.sections.${key}`, { returnObjects: true });
    const list = (key) => {
        const v = t(key, { returnObjects: true });
        return Array.isArray(v) ? v : [];
    };

    const intro = S("intro");
    const collect = S("collect");
    const purposes = S("purposes");
    const legal = S("legal");
    const processors = S("processors");
    const push = S("push");
    const retention = S("retention");
    const visibility = S("visibility");
    const security = S("security");
    const rights = S("rights");
    const deletion = S("deletion");
    const minors = S("minors");
    const changes = S("changes");
    const contact = S("contact");

    return (
        <div
            style={{
                maxWidth: 900,
                margin: "40px auto",
                padding: "20px",
                background: "#fff",
                borderRadius: 12,
                boxShadow: "0 4px 10px rgba(0,0,0,0.08)",
                fontFamily: "Arial, sans-serif",
                lineHeight: 1.6,
                color: "#222",
            }}
        >
            <h2 style={{ color: "var(--primary-blue)", textAlign: "center", marginBottom: 10 }}>
                {t("privacy.title")}
            </h2>

            <p style={{ textAlign: "center", color: "#666", marginTop: 0 }}>
                {t("privacy.appName")} — {t("privacy.version")} <strong>{PRIVACY_VERSION}</strong>
            </p>

            <hr style={{ margin: "18px 0", borderColor: "#eee" }} />

            {/* 1. Introduction / responsable */}
            <h3>{intro.title}</h3>
            <p>{intro.content}</p>

            {/* 2. Données collectées */}
            <h3>{collect.title}</h3>
            <p>{collect.intro}</p>
            <ul style={{ paddingLeft: 18 }}>
                {list("privacy.sections.collect.items").map((it, i) => (
                    <li key={i}>{it}</li>
                ))}
            </ul>

            {/* 3. Finalités */}
            <h3>{purposes.title}</h3>
            <p>{purposes.intro}</p>
            <ul style={{ paddingLeft: 18 }}>
                {list("privacy.sections.purposes.items").map((it, i) => (
                    <li key={i}>{it}</li>
                ))}
            </ul>

            {/* 4. Base légale */}
            <h3>{legal.title}</h3>
            <p>{legal.content}</p>

            {/* 5. Sous-traitants */}
            <h3>{processors.title}</h3>
            <p>{processors.intro}</p>
            <ul style={{ paddingLeft: 18 }}>
                {list("privacy.sections.processors.items").map((it, i) => (
                    <li key={i}>{it}</li>
                ))}
            </ul>
            <p>{processors.note}</p>

            {/* 6. Notifications push */}
            <h3>{push.title}</h3>
            <p>{push.content}</p>

            {/* 7. Durée de conservation */}
            <h3>{retention.title}</h3>
            <p>{retention.content}</p>

            {/* 8. Visibilité entre utilisateurs */}
            <h3>{visibility.title}</h3>
            <p>{visibility.content}</p>

            {/* 9. Sécurité */}
            <h3>{security.title}</h3>
            <p>{security.content}</p>

            {/* 10. Droits */}
            <h3>{rights.title}</h3>
            <p>{rights.intro}</p>
            <ul style={{ paddingLeft: 18 }}>
                {list("privacy.sections.rights.items").map((it, i) => (
                    <li key={i}>{it}</li>
                ))}
            </ul>
            <p>{rights.exercise}</p>

            {/* 11. Suppression du compte */}
            <h3>{deletion.title}</h3>
            <p>{deletion.content}</p>

            {/* 12. Mineurs */}
            <h3>{minors.title}</h3>
            <p>{minors.content}</p>

            {/* 13. Modifications */}
            <h3>{changes.title}</h3>
            <p>{changes.content}</p>

            {/* 14. Contact */}
            <h3>{contact.title}</h3>
            <p>
                {contact.content} <strong>contact@swissdiveagenda.ch</strong>
            </p>

            <hr style={{ margin: "18px 0", borderColor: "#eee" }} />

            <button
                type="button"
                onClick={() => {
                    window.close();
                    setTimeout(() => {
                        window.location.href = "/";
                    }, 150);
                }}
                style={{
                    width: "100%",
                    padding: "10px",
                    background: "var(--primary-blue)",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: "pointer",
                    fontWeight: "bold",
                    marginTop: 18,
                }}
            >
                {t("common.close")}
            </button>
        </div>
    );
}
